import {
    Component,
    HostListener,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation,
    Output,
    EventEmitter
} from '@angular/core';
import { MatLegacyCheckbox as MatCheckbox, MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { TranslateService } from '@ngx-translate/core';
import { VaultUploadDialogLocalComponent } from 'app/pages/vault';
import {
    DepthDurationFrequency,
    DdfTable,
    DryDayDefinition,
    StormDefinition,
    DryDefinitionDetails,
    WasteWaterBaseInfiltration,
    BaseInfiltrationMethod,
    DailyMaximum,
    UIDdfTable,
    uItoAPIDDfTable,
    BaseInfiltrationCalculationOption,
} from 'app/shared/models/sliicer/customer-rainfall-profile';
import { SnackBarNotificationService } from 'app/shared/services/snack-bar-notification.service';
import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { DdfGraphComponent, DDFGraphData } from 'app/shared/components/ddf-graph/ddf-graph.component';
import { UnitOfMeasureType } from '../../../shared/constant';
import { SharedService } from 'app/shared/services/shared.service';
import { CustomerService } from 'app/shared/services/customer.service';
import { Customer, SliicerUserConfig } from 'app/shared/models/customer';
import { VaultFile, VaultUpload } from 'app/shared/models/vault';
import { SelectItem } from 'app/shared/models/selected-Item';
import { IDataTransfer } from 'app/shared/models/modal';
import { DomOperationUtilsService } from 'app/shared/utils/dom-operation-utils.service';
import { MatLegacyTabChangeEvent as MatTabChangeEvent, MatLegacyTabGroup as MatTabGroup } from '@angular/material/legacy-tabs';
import { NgForm } from '@angular/forms';
import { forkJoin, Observable, of } from 'rxjs';
import { TrackBy } from 'app/shared/utils/track-by';
import { MatTable } from '@angular/material/table';
import { MatSelectChange } from '@angular/material/select';
import { catchError, map, tap } from 'rxjs/operators';
import { isEqual } from 'lodash';

const CSV_FILE_TYPE = 'text/csv';
const SNACKBAR_DURATION = 10000;
const DAY_MIN_CONVERSION = 1440;
const HR_MIN_CONVERSION = 60;
const HR_DAY_CONVERSION = 24;
interface DryDefinitionState {
    minRainPrevOneDay: number | null;
    minRainPrevThreeDays: number | null;
    minRainPrevFiveDays: number | null;
    minimumFlowPercentage: number | null;
    maximumFlowPercentage: number | null;
}

interface StormDefinitionState {
    minRainfallThreshold: number | null;
    minimumTimeBetweenEventsMinutes: number | null;
}

interface WasteWaterState {
    infiltrationType: BaseInfiltrationCalculationOption;
    method: BaseInfiltrationMethod;
    constant: number | null;
}

interface DdfRowState {
    durationMinutes: number | null;
    month2: number | null;
    month3: number | null;
    month4: number | null;
    month6: number | null;
    month9: number | null;
    year1: number | null;
    year2: number | null;
    year5: number | null;
    year10: number | null;
    year25: number | null;
    year50: number | null;
    year100: number | null;
    year200: number | null;
    year500: number | null;
    year1000: number | null;
}

interface DdfState {
    rows: DdfRowState[];
    visibleColumns: string[];
}

const ddfTableColumnNames = [
    'duration',
    '2mo',
    '3mo',
    '4mo',
    '6mo',
    '9mo',
    '1yr',
    '2yr',
    '5yr',
    '10yr',
    '25yr',
    '50yr',
    '100yr',
    '200yr',
    '500yr',
    '1000yr',
];
@Component({
    selector: 'app-customer-rain-profile',
    templateUrl: './customer-rain-profile.component.html',
    styleUrls: ['./customer-rain-profile.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CustomerRainProfileComponent implements OnInit, OnChanges, OnDestroy {
    @ViewChild('ddfGraph') public ddfGraphComponent: DdfGraphComponent;
    @ViewChild('dryDefinitionForm', { static: true }) public dryDefinitionForm: NgForm;
    @ViewChild('stormDefnitionForm', { static: true }) public stormDefnitionForm: NgForm;
    @ViewChild('CustomerWasteWaterForm', { static: true }) public CustomerWasteWaterForm: NgForm;

    @ViewChild('table') public matTable: MatTable<MatTableDataSource<UIDdfTable>>;;

    public ddfTableColumns = ddfTableColumnNames;
    public ddfTableColumnDefs: { name: string; show: boolean }[] = ddfTableColumnNames.map((v) => ({
        name: v,
        show: true,
    }));
    @Input('customerDetails') public customerDetails: Customer;
    @Input('customerUnit') public customerUnit: number;
    @Output() public rainfallProfileChanged = new EventEmitter<boolean>();

    public BaseInfiltrationMethod = BaseInfiltrationMethod;

    public percentagePattern = REGEX_CONFIG.numeric0_100With6DecimalPlacesPattern;
    public numericValidationPattern = REGEX_CONFIG.numericGeneralPattern;
    public numericWith2DecimalPlaces = REGEX_CONFIG.numericWith2DecimalPlaces;
    public numericWith1DecimalPlaces = REGEX_CONFIG.numericWith1DecimalPlaces;
    public isPositiveInteger = REGEX_CONFIG.isPositiveInteger;
    public isDryDayDefFormChanges = true;
    public isStormDefFormChange = true;
    public cusWasteWaterFormChange = true;

    public selectedOptions: string[];
    public IsUnitMetric = true;
    public saveDisabled = false;

    public dryDefinitionDetails = new DryDefinitionDetails();

    public stormDefinitionDetails: StormDefinition = {
        minRainfallThreshold: '0',
        minimumTimeBetweenEventsMinutes: 0,
    };

    public isLoadingState: boolean;
    public ddfFormChange: boolean;

    public dismissBtn: string;

    public stormCreationSuccessfultxt: string;
    public savedDdfText: string;
    public failedDdfText: string;

    public stormCreationFailurefultxt: string;

    public dryDayCreationSuccessfultxt: string;

    public dryDayCreationFailuretxt: string;

    public infiltrationType: BaseInfiltrationCalculationOption = BaseInfiltrationCalculationOption.Gross;
    public wasteWaterInflitrationCalculationOptions: BaseInfiltrationCalculationOption[] = [
        BaseInfiltrationCalculationOption.Gross,
        BaseInfiltrationCalculationOption.Net,
    ];
    public wasteWaterInflitrationCalculationNames = {
        [BaseInfiltrationCalculationOption.Net]: 'SLIICER_TABLE.SLICER_SUMMARY.INFILTRATION_CALC_NET',
        [BaseInfiltrationCalculationOption.Gross]: 'SLIICER_TABLE.SLICER_SUMMARY.INFILTRATION_CALC_GROSS',
    };
    public wasteWaterMethod: BaseInfiltrationMethod = BaseInfiltrationMethod.StevensSchutzbach;
    public wasteWaterMethodName = '';
    public wasteWaterConstant: number;
    public wasteWaterMethodOptions: Array<SelectItem> = [];
    public state = {
        infiltrationType: BaseInfiltrationCalculationOption.Gross,
        method: BaseInfiltrationMethod.StevensSchutzbach,
        constant: null as number | null
    };
    public isStudyLocked = false;
    public wasteWaterMethodDescriptions = {
        [BaseInfiltrationMethod.PercentMinimum]: 'SLIICER_TABLE.SLICER_SUMMARY.WASTEWATER_MINIMUM_DESC',
        [BaseInfiltrationMethod.Mitchell]: 'SLIICER_TABLE.SLICER_SUMMARY.WASTEWATER_MITCHELL_DESC',
        [BaseInfiltrationMethod.StevensSchutzbach]: 'SLIICER_TABLE.SLICER_SUMMARY.WASTEWATER_METHOD_DESC',
        [BaseInfiltrationMethod.WastewaterProduction]: 'SLIICER_TABLE.SLICER_SUMMARY.WASTEWATER_PRODUCTION_DESC',
    };
    public ddfTableSource: MatTableDataSource<UIDdfTable>;
    public rainfallDataColumns: string[];
    public ddf: DepthDurationFrequency;
    public ddfData: UIDdfTable[];
    public deleteColumn = 'checked';
    public deleteButton = false;
    public durationOptions = ['min', 'hr', 'days'];
    public clicked = false;
    public status = false;
    public noFileMsg: string;
    public csvUploadFilesErr: string;
    public chooseCsvFileMsg: string;
    public filesUploadErr: string;
    public filesUploadSuccessMsg: string;
    public unitInInch: string;
    public unitInMM: string;
    public uploadVaultFile: VaultFile;
    public isDepthDurationHeaderChecked: boolean;
    public tempData: {[key: string]: (string | number)[]} = {};
    public data = [
        'month2',
        'month3',
        'month4',
        'month6',
        'month9',
        'year1',
        'year2',
        'year5',
        'year10',
        'year25',
        'year50',
        'year100',
        'year200',
        'year500',
        'year1000',
    ];
    public finalData = {};
    public unit: string;
    public filterOptions = [
        '2mo',
        '3mo',
        '4mo',
        '6mo',
        '9mo',
        '1yr',
        '2yr',
        '5yr',
        '10yr',
        '25yr',
        '50yr',
        '100yr',
        '200yr',
        '500yr',
        '1000yr',
    ];
    private rainFallDepthDurationRowDeletionMsg: string;
    public savedMethod: string;
    public failedToSave: string;
    public wasteWaterId: string;
    public hr: string;
    public minute: string;
    public days: string;
    public baseMethod: BaseInfiltrationMethod;
    public baseConstant: number;
    public columnIndex = 0;
    private badDDFFormatText: string;
    private userConfig: SliicerUserConfig = null;
    private savedDryDefinitionState?: DryDefinitionState;
    private savedStormDefinitionState?: StormDefinitionState;
    private savedWasteWaterState?: WasteWaterState;
    private savedDdfState?: DdfState;
    private ddfDataLoaded = false;
    private userConfigLoaded = false;

    public trackByName = TrackBy.byUniqueKey<{ name: string }>()('name');
    public trackByIndex = TrackBy.byIndex;
    constructor(
        private customerService: CustomerService,
        private sharedService: SharedService,
        private snackBarNotificationService: SnackBarNotificationService,
        private dialog: MatDialog,
        private translate: TranslateService,
        public domOperationUtilsService: DomOperationUtilsService,
    ) {
    }
    /**
      oninit lifecyclehook used to fetch static text
    **/
    public ngOnInit() {
        this.updateDdfChangeState();

        this.domOperationUtilsService.rainfallTabIndex.next(0);
        this.domOperationUtilsService.ddfTabIndex.next(0);

        this.rainfallDataColumns = this.ddfTableColumns;
        this.selectedOptions = []; // hide column Checkbox should be unchecked as default;;
        this.wasteWaterConstant = 80;
        this.applyTranslations();

        const translateMethodKeys = [
            { key: 'SLIICER_TABLE.SLICER_SUMMARY.WASTEWATER_MINIMUM', value: BaseInfiltrationMethod.PercentMinimum },
            { key: 'SLIICER_TABLE.SLICER_SUMMARY.WASTEWATER_MITCHELL', value: BaseInfiltrationMethod.Mitchell },
            { key: 'SLIICER_TABLE.SLICER_SUMMARY.WASTEWATER_METHOD', value: BaseInfiltrationMethod.StevensSchutzbach },
            { key: 'SLIICER_TABLE.SLICER_SUMMARY.WASTEWATER_PRODUCTION', value: BaseInfiltrationMethod.WastewaterProduction },
        ];

        this.translate.get(translateMethodKeys.map((k) => k.key)).subscribe((values: Array<string>) => {
            let index = 0;

            translateMethodKeys.forEach((item) => {
                const value: SelectItem = {
                    id: index++,
                    name: item.value,
                    text: values[item.key],
                };

                this.wasteWaterMethodOptions.push(value);
            });
        });
    }

    /**
      onchanges lifecyclehook used to fetch existing storm and dry day definitions of customer
    **/
    public ngOnChanges(changes: SimpleChanges) {
        if (this.customerDetails) {
            this.savedDryDefinitionState = undefined;
            this.savedStormDefinitionState = undefined;
            this.savedWasteWaterState = undefined;
            this.savedDdfState = undefined;
            this.ddfDataLoaded = false;
            this.userConfigLoaded = false;
            this.ddfTableColumnDefs.forEach((column: { name: string; show: boolean }) => column.show = true);
            this.updateDDFColumns();
            this.getStormDifinitionData();
            this.getDryDefinitionData();
            this.getDepthDurationFrequency();
            this.getWasteWaterInfilteration();
            this.initializeChartSettings();
            this.getUserConfig();
        }
    }

    public minRainfall1DayChange(): void {
        this.updateRainfallChangeState();
    }

    public minRainfall3DayChange(): void {
        this.updateRainfallChangeState();
    }

    public minRainfall5DayChange(): void {
        this.updateRainfallChangeState();
    }

    public minFlowPrecentageChange(): void {
        this.updateRainfallChangeState();
    }

    public maxFlowPrecentageChange(): void {
        this.updateRainfallChangeState();
    }

    public minRainfallThresholdChange(): void {
        this.updateRainfallChangeState();
    }

    public onSelectCalcOptionChange(value: BaseInfiltrationCalculationOption) {
        this.state.infiltrationType = value;
        this.infiltrationType = value;
        this.CustomerWasteWaterForm.form.markAsDirty();
        this.updateRainfallChangeState();
    }

    public getInfiltrationTypeTooltip(type: BaseInfiltrationCalculationOption): string {
        switch (type) {
            case BaseInfiltrationCalculationOption.Net:
                return this.translate.instant('SLIICER_TABLE.SLICER_SUMMARY.INFILTRATION_CALC_NET_TOOLTIP');
            case BaseInfiltrationCalculationOption.Gross:
                return this.translate.instant('SLIICER_TABLE.SLICER_SUMMARY.INFILTRATION_CALC_GROSS_TOOLTIP');
            default:
                return '';
        }
    }

    public minTimeBwStormEventsChange(): void {
        this.updateRainfallChangeState();
    }

    public getWasteWaterInfilteration() {
        this.isLoadingState = true;
        this.wasteWaterMethodName = this.wasteWaterMethodOptions[0]?.text;
        this.customerService.getWasteWaterMethod(this.customerDetails.customerID).subscribe(
            (result: WasteWaterBaseInfiltration) => {
                this.isLoadingState = false;
                if (result) {
                    this.wasteWaterId = result.id;
                    this.wasteWaterMethod = result.method;
                    this.wasteWaterConstant = result.constant;
                    this.infiltrationType = result.infiltrationType || BaseInfiltrationCalculationOption.Gross;
                    this.state.infiltrationType = this.infiltrationType;
                    this.state.method = this.wasteWaterMethod;
                    this.state.constant = this.wasteWaterConstant;
                    this.baseMethod = this.wasteWaterMethod;
                    this.baseConstant = this.wasteWaterConstant;
                    const wasterWater: SelectItem = this.wasteWaterMethodOptions.find(
                        (item) => item.name === this.wasteWaterMethod,
                    );
                    this.wasteWaterMethodName = wasterWater ? wasterWater.text : this.wasteWaterMethodOptions[0].text;
                }
                this.savedWasteWaterState = this.getCurrentWasteWaterState();
                this.CustomerWasteWaterForm?.form?.markAsPristine();
                this.updateRainfallChangeState();
            },
            (error) => {
                this.isLoadingState = false;
            },
        );
    }

    public applyDdfSource(data: UIDdfTable[], shouldSort = true) {
        if(data && shouldSort) {
            const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
            const compareFn = (r1:UIDdfTable, r2: UIDdfTable) => collator.compare(r1.durationvalue, r2.durationvalue);
            data.sort(compareFn);
        }

        if(this.ddfTableSource) {
            this.ddfTableSource.data = data;
        } else {
            this.ddfTableSource = new MatTableDataSource(data);
        }
    }

    public saveWasteWaterMethod(): void {
        this.saveWasteWaterMethod$(true).subscribe();
    }

    public hasPendingChanges(): boolean {
        return this.hasDryDefinitionChanges()
            || this.hasStormDefinitionChanges()
            || this.hasWasteWaterChanges()
            || this.hasDdfChanges();
    }

    public hasInvalidPendingChanges(): boolean {
        return (this.hasDryDefinitionChanges() && this.dryDefinitionForm.form.invalid)
            || (this.hasStormDefinitionChanges() && this.stormDefnitionForm.form.invalid)
            || (this.hasWasteWaterChanges() && this.CustomerWasteWaterForm.form.invalid);
    }

    public savePendingChanges(showSuccessNotification = true): Observable<boolean> {
        if (!this.hasPendingChanges()) {
            return of(true);
        }

        if (this.hasInvalidPendingChanges()) {
            this.markPendingFormsTouched();
            return of(false);
        }

        const saveOperations: Array<Observable<boolean>> = [];

        if (this.hasDryDefinitionChanges()) {
            saveOperations.push(this.createDryDayDefinition$(showSuccessNotification));
        }

        if (this.hasStormDefinitionChanges()) {
            saveOperations.push(this.createStormDefinition$(showSuccessNotification));
        }

        if (this.hasWasteWaterChanges()) {
            saveOperations.push(this.saveWasteWaterMethod$(showSuccessNotification));
        }

        if (this.hasDdfChanges()) {
            saveOperations.push(this.saveDepthDurationFrequency$(showSuccessNotification));
        }

        if (saveOperations.length === 0) {
            return of(true);
        }

        return forkJoin(saveOperations).pipe(
            map((results: boolean[]) => results.every((result: boolean) => result)),
        );
    }

    private saveWasteWaterMethod$(showSuccessNotification: boolean): Observable<boolean> {
        this.isLoadingState = true;
        const wasteWaterValue: WasteWaterBaseInfiltration = {
            infiltrationType: this.infiltrationType,
            method: this.wasteWaterMethod,
            constant: this.wasteWaterConstant,
            id: this.wasteWaterId,
        };

        return this.customerService.saveWasteWaterMethod(this.customerDetails.customerID, wasteWaterValue).pipe(
            tap(() => {
                if (showSuccessNotification) {
                    this.snackBarNotificationService.raiseNotification(this.savedMethod, this.dismissBtn, {
                        duration: SNACKBAR_DURATION,
                    });
                }
                this.isLoadingState = false;
                this.saveDisabled = true;
                this.baseMethod = this.wasteWaterMethod;
                this.baseConstant = this.wasteWaterConstant;
                this.savedWasteWaterState = this.getCurrentWasteWaterState();
                this.CustomerWasteWaterForm.form.markAsPristine();
                this.updateRainfallChangeState();
            }),
            map(() => true),
            catchError(() => {
                this.isLoadingState = false;
                this.snackBarNotificationService.raiseNotification(this.failedToSave, this.dismissBtn, {
                    panelClass: 'custom-error-snack-bar',
                }, false);
                return of(false);
            }),
        );
    }

    private hasDryDefinitionChanges(): boolean {
        return !!this.savedDryDefinitionState
            && !isEqual(this.savedDryDefinitionState, this.getCurrentDryDefinitionState());
    }

    private hasStormDefinitionChanges(): boolean {
        return !!this.savedStormDefinitionState
            && !isEqual(this.savedStormDefinitionState, this.getCurrentStormDefinitionState());
    }

    private hasWasteWaterChanges(): boolean {
        return !!this.savedWasteWaterState
            && !isEqual(this.savedWasteWaterState, this.getCurrentWasteWaterState());
    }

    private hasDdfChanges(): boolean {
        return !!this.savedDdfState && !isEqual(this.savedDdfState, this.getCurrentDdfState());
    }

    private getCurrentDryDefinitionState(): DryDefinitionState {
        return {
            minRainPrevOneDay: this.normalizeNumber(this.dryDefinitionDetails.minRainPrevOneDay),
            minRainPrevThreeDays: this.normalizeNumber(this.dryDefinitionDetails.minRainPrevThreeDays),
            minRainPrevFiveDays: this.normalizeNumber(this.dryDefinitionDetails.minRainPrevFiveDays),
            minimumFlowPercentage: this.normalizeNumber(this.dryDefinitionDetails.minimumFlowPercentage),
            maximumFlowPercentage: this.normalizeNumber(this.dryDefinitionDetails.maximumFlowPercentage),
        };
    }

    private getCurrentStormDefinitionState(): StormDefinitionState {
        return {
            minRainfallThreshold: this.normalizeNumber(this.stormDefinitionDetails.minRainfallThreshold),
            minimumTimeBetweenEventsMinutes: this.normalizeNumber(
                this.stormDefinitionDetails.minimumTimeBetweenEventsMinutes,
            ),
        };
    }

    private getCurrentWasteWaterState(): WasteWaterState {
        return {
            infiltrationType: this.infiltrationType,
            method: this.wasteWaterMethod,
            constant: this.normalizeNumber(this.wasteWaterConstant),
        };
    }

    private getCurrentDdfState(): DdfState {
        return {
            rows: (this.ddfData ?? []).map((row: UIDdfTable) => this.getDdfRowState(row)),
            visibleColumns: this.ddfTableColumnDefs
                .filter((column: { name: string; show: boolean }) => column.show)
                .map((column: { name: string; show: boolean }) => column.name),
        };
    }

    private getDdfRowState(row: UIDdfTable): DdfRowState {
        return {
            durationMinutes: this.getDurationInMinutes(row.durationMinutes, row.duration),
            month2: this.normalizeNumber(row.month2),
            month3: this.normalizeNumber(row.month3),
            month4: this.normalizeNumber(row.month4),
            month6: this.normalizeNumber(row.month6),
            month9: this.normalizeNumber(row.month9),
            year1: this.normalizeNumber(row.year1),
            year2: this.normalizeNumber(row.year2),
            year5: this.normalizeNumber(row.year5),
            year10: this.normalizeNumber(row.year10),
            year25: this.normalizeNumber(row.year25),
            year50: this.normalizeNumber(row.year50),
            year100: this.normalizeNumber(row.year100),
            year200: this.normalizeNumber(row.year200),
            year500: this.normalizeNumber(row.year500),
            year1000: this.normalizeNumber(row.year1000),
        };
    }

    private getDurationInMinutes(value?: string | number | null, unit?: string): number | null {
        const normalizedValue = this.normalizeNumber(value);
        if (normalizedValue === null) {
            return null;
        }

        if (unit === this.hr || unit === this.durationOptions[1]) {
            return normalizedValue * HR_MIN_CONVERSION;
        }
        if (unit === this.days || unit === this.durationOptions[2]) {
            return normalizedValue * DAY_MIN_CONVERSION;
        }
        return normalizedValue;
    }

    private normalizeNumber(value?: string | number | null): number | null {
        if (value === null || value === undefined || value === '') {
            return null;
        }

        const normalizedValue = Number(value);
        return Number.isNaN(normalizedValue) ? null : normalizedValue;
    }

    private updateRainfallChangeState(): void {
        this.ddfFormChange = this.hasDdfChanges();
        this.saveDisabled = !this.hasWasteWaterChanges();
        this.rainfallProfileChanged.emit(this.hasPendingChanges());
    }

    private captureDdfStateIfLoaded(): void {
        if (!this.ddfDataLoaded || !this.userConfigLoaded) {
            return;
        }

        this.savedDdfState = this.getCurrentDdfState();
        this.updateRainfallChangeState();
    }

    private markPendingFormsTouched(): void {
        if (this.hasDryDefinitionChanges()) {
            this.dryDefinitionForm.form.markAllAsTouched();
        }

        if (this.hasStormDefinitionChanges()) {
            this.stormDefnitionForm.form.markAllAsTouched();
        }

        if (this.hasWasteWaterChanges()) {
            this.CustomerWasteWaterForm.form.markAllAsTouched();
        }
    }

    public selectConstantChange(): void
    {
        this.updateRainfallChangeState();
    }

    public onSelectedTabChange(event: MatTabChangeEvent, tabGroup: MatTabGroup): void {
        tabGroup.selectedIndex = event.index;
    }

    public onDDFtabChange(event: MatTabChangeEvent) {
        this.domOperationUtilsService.ddfTabIndex.next(event.index);
    }

    public onSelectMethodChange(event: MatSelectChange): void {
        this.wasteWaterMethodName = (event.value as string).trim();

        if (event.value === BaseInfiltrationMethod.PercentMinimum && this.baseMethod !== BaseInfiltrationMethod.PercentMinimum) {
            this.wasteWaterConstant = 80;
        } else if (event.value === BaseInfiltrationMethod.StevensSchutzbach) {
            this.wasteWaterConstant = 0;
        } else if (event.value === BaseInfiltrationMethod.WastewaterProduction && this.baseMethod !== BaseInfiltrationMethod.WastewaterProduction) {
            this.wasteWaterConstant = 88;
        } else {
            this.wasteWaterConstant = this.baseConstant;
        }
        this.updateRainfallChangeState();
    }
    public isSchutzbach(method: BaseInfiltrationMethod) {
        return method === BaseInfiltrationMethod.StevensSchutzbach;
    }
    public isMitchell(method: BaseInfiltrationMethod) {
        return method === BaseInfiltrationMethod.Mitchell;
    }
    /** Depth duration frequency */
    public openUploadDepthDurationDialog($event: MouseEvent, fileType?: string): void {
        // setup initial url
        fileType = CSV_FILE_TYPE;

        this.dialog
            .open(VaultUploadDialogLocalComponent, {
                data: <IDataTransfer>{
                    fileType: fileType,
                },
                panelClass: 'file-upload-background-panel',
                disableClose: true,
            })
            .afterClosed()
            .subscribe(
                (vaultUpload: VaultUpload) => {
                    // if upload fails
                    if (vaultUpload === null) {
                        return;
                    }
                    if (vaultUpload) {
                        let uploadContainsNaN = false;
                        const response = JSON.parse(vaultUpload.response);
                        this.ddfData = response.ddfTable;
                        this.ddfData.forEach((element) => {
                            element.duration = this.minute;
                            element.durationvalue = element.durationMinutes;
                            this.data.forEach((d) => {
                                element[d] = this.applyUnitRounding(element[d]);
                                if(isNaN(element[d])){
                                    uploadContainsNaN = true;
                                }
                            });
                        });
                        if(this.ddfData.length === 0 || uploadContainsNaN)
                        {
                            this.snackBarNotificationService.raiseNotification(this.badDDFFormatText, this.dismissBtn, {
                                panelClass: 'custom-error-snack-bar',
                            }, false);
                        }
                        else{
                            this.applyDdfSource(this.ddfData);
                            this.ddfGraph(this.ddfData, this.unit);
                        }
                        this.updateDdfChangeState();
                    }
                },
                (error) => {
                    // Error Block to handle errors
                    this.updateDdfChangeState();
                },
            );

        if (fileType === CSV_FILE_TYPE) {
            this.sharedService.setFileUploadMessage(this.chooseCsvFileMsg);
        }
    }
    /**DDF Column Filter */
    @HostListener('document:click', ['$event'])
    public clickout(event) {
        this.status = false;
    }

    public openFilterMenu(event: Event) {
        this.status = true;
        event.stopPropagation();
    }

    public ddfFilter(values) {
        const columnNameArr: string[] = [];
        this.ddfTableColumns.forEach((ele) => {
            if (values.indexOf(ele) === -1 && ele !== 'duration') {
                columnNameArr.push(ele);
            }
        });
        this.rainfallDataColumns = columnNameArr;
        this.rainfallDataColumns.unshift('duration');
    }

    /**Method to convert duration values based on selected unit value */
    public onDurationUnitChange(event, index: number) {
        if (
            this.ddfData &&
            this.ddfData.length > 0 &&
            this.ddfData[index] &&
            this.ddfData[index].durationMinutes &&
            event &&
            event.value &&
            event.source &&
            event.source.ngControl
        ) {
            const durationStr = this.ddfData[index].durationMinutes,
                newValue = event.value,
                oldValue = event.source.ngControl.model;
            const duration = parseInt(durationStr);
            let result: number;
            if (oldValue === this.durationOptions[0]) {
                if (newValue === this.durationOptions[2]) {
                    result = duration / DAY_MIN_CONVERSION;
                } else if (newValue === this.durationOptions[1]) {
                    result = duration / HR_MIN_CONVERSION;
                }
            } else if (oldValue === this.durationOptions[2]) {
                if (newValue === this.durationOptions[1]) {
                    result = duration * HR_DAY_CONVERSION;
                } else if (newValue === this.durationOptions[0]) {
                    result = duration * DAY_MIN_CONVERSION;
                }
            } else if (oldValue === this.durationOptions[1]) {
                if (newValue === this.durationOptions[0]) {
                    result = duration * HR_MIN_CONVERSION;
                } else if (newValue === this.durationOptions[2]) {
                    result = duration / HR_DAY_CONVERSION;
                }
            }
            this.ddfData[index].durationMinutes = `${result}`;
            this.applyDdfSource(this.ddfData, false);
        }
        this.updateDdfChangeState();
    }
    /** To add new row in ddf table */
    public addNewRow(trackChanges = true): void {
        this.clearSelectedRow();
        this.ddfData.push({
            month1: null,
            month2: null,
            month3: null,
            month4: null,
            month6: null,
            month9: null,
            year1: null,
            year2: null,
            year5: null,
            year10: null,
            year25: null,
            year50: null,
            year100: null,
            year200: null,
            year500: null,
            year1000: null,
            durationvalue: null,
            durationMinutes: null,
            duration: this.minute,
        });
        this.applyDdfSource(this.ddfData, false);
        if (trackChanges) {
            this.updateDdfChangeState();
        }
    }
    /** To delete rows in ddf table **/
    public deleteRow() {
        this.rainfallDataColumns.unshift(this.deleteColumn);
        this.deleteButton = true;
    }

    public deleteSelectedRow() {
        this.ddfData = this.ddfTableSource.data.filter((elements) => !elements.checked);
        this.applyDdfSource(this.ddfData, false);
        this.ddfGraph(this.ddfData, this.unit);
        this.snackBarNotificationService.raiseNotification(this.rainFallDepthDurationRowDeletionMsg, this.dismissBtn);
        this.updateDdfChangeState();
        this.clearSelectedRow();
    }

    public clearSelectedRow() {
        if (this.rainfallDataColumns.some((column: string) => column === this.deleteColumn)) {
            this.rainfallDataColumns.shift();
        }
        this.deleteButton = false;
        this.isDepthDurationHeaderChecked = false;
        if (this.ddfTableSource && this.ddfTableSource.data) {
            this.ddfTableSource.data.forEach((item) => (item.checked = false));
        }
    }

    public depthDurationCheckBoxAll(event: MatCheckbox) {
        if (this.ddfTableSource.data) {
            this.ddfTableSource.data.forEach((item) => (item.checked = event.checked));
        }
        this.applyDdfSource(this.ddfData, false);
    }

    public depthDurationCheckBox(event: MatCheckbox) {
        if (this.ddfTableSource.data) {
            const selectedItems = this.ddfTableSource.data.filter((item) => item.checked) || [];
            this.isDepthDurationHeaderChecked = this.ddfTableSource.data.length === selectedItems.length;
        }
    }
    /** DDF Graph */
    public ddfGraph(ddfValues: UIDdfTable[], unitOfMeasure: string) {
        this.data.forEach((dataValue) => {
            this.finalData[dataValue] = [];
            this.tempData[dataValue] = [];
        });

        ddfValues.forEach((element) => {
            this.data.forEach((val) => {
                const value: number = !element[val] || element[val] === '' ? 0 : parseFloat(element[val]);
                if (!!value) {
                    this.tempData[val].push(element.durationMinutes);
                    this.tempData[val].push(value);
                    this.finalData[val].push(this.tempData[val]);
                    this.tempData[val] = [];
                }
            });
        });

        const seriesData: DDFGraphData[] = [];
        this.data.forEach((series) => {
            const points = this.finalData[series];
            if (points && points.length > 0) {
                const obj: DDFGraphData = {
                    name: this.splitLegendText(series),
                    data: this.finalData[series],
                    pointStart: 5,
                    showInLegend: false,
                    color: '#999',
                };
                seriesData.push(obj);
            }
        });
        this.ddfGraphComponent.generateDdfGraph(seriesData);
    }

    public ngOnDestroy() {
        if (this.ddfGraphComponent.chart) {
            this.ddfGraphComponent.chart.destroy();
        }
    }

    /**
     * This method will modify ddf chart legend from month-year to year-month
     * @param {String} value: receive as legend string as parameter
     */
    public splitLegendText(value: string) {
        const matchVal = value ? value.match(/\d+/) : value;
        if (matchVal) {
            const numInValue = matchVal[0];
            const index = value.indexOf(numInValue);
            const txt = value.substring(0, index) + ',' + value.substring(index);
            return txt.split(',')[1] + ' ' + txt.split(',')[0];
        } else {
            return value;
        }
    }

    /**
     * TODO: #45912 - durationValue is mixing with durationMinutes
     * Currently row for a one day is represented like this:
     * duration: "days", durationMinutes: 1, durationvalue: "1440"
     */

    public getDepthDurationFrequency() {
        this.isLoadingState = true;
        this.customerService.getDepthDuration(this.customerDetails.customerID).subscribe(
            (result: DepthDurationFrequency) => {
                if (result.ddfTable) {
                    const ddfTempData: UIDdfTable[] = [];
                    result.ddfTable.forEach((element) => {
                        const newRow: UIDdfTable = {
                            durationvalue: `${element.durationvalue ?? element.durationMinutes}`,
                            durationMinutes: `${element.durationMinutes}`,
                            duration: this.minute,
                            month2: this.applyUnitRounding(element.month2),
                            month3: this.applyUnitRounding(element.month3),
                            month4: this.applyUnitRounding(element.month4),
                            month6: this.applyUnitRounding(element.month6),
                            month9: this.applyUnitRounding(element.month9),
                            year1: this.applyUnitRounding(element.year1),
                            year2: this.applyUnitRounding(element.year2),
                            year5: this.applyUnitRounding(element.year5),
                            year10: this.applyUnitRounding(element.year10),
                            year25: this.applyUnitRounding(element.year25),
                            year50: this.applyUnitRounding(element.year50),
                            year100: this.applyUnitRounding(element.year100),
                            year200: this.applyUnitRounding(element.year200),
                            year500: this.applyUnitRounding(element.year500),
                            year1000: this.applyUnitRounding(element.year1000)
                        }
                        ddfTempData.push(newRow);
                    });
                    this.ddfData = ddfTempData;
                    this.ddf = result;
                    this.applyDdfSource(this.ddfData);
                    this.ddfGraph(this.ddfData, this.unit);
                } else {
                    this.ddfData = [];
                    this.addNewRow(false);
                    this.applyDdfSource(this.ddfData);
                }
                this.ddfDataLoaded = true;
                this.captureDdfStateIfLoaded();
                this.isLoadingState = false;
            },
            () => {
                this.ddfDataLoaded = true;
                this.captureDdfStateIfLoaded();
                this.isLoadingState = false;
            },
        );
    }

    /** To save DDF table data */
    public saveDepthDurationFrequency(): void {
        this.saveDepthDurationFrequency$(true).subscribe();
    }

    private saveDepthDurationFrequency$(showSuccessNotification: boolean): Observable<boolean> {
        this.isLoadingState = true;
        if (!this.ddfData) {
            this.isLoadingState = false;
            return of(true);
        }

        const durations: Array<{ type: string; value: string }> = this.ddfData.map((v: UIDdfTable) => ({ type: v.duration, value: v.durationMinutes }));
        const tableDataCopy: UIDdfTable[] = this.ddfData.map((x: UIDdfTable) => Object.assign({}, x));
        tableDataCopy.forEach((row: UIDdfTable) => {
            Object.keys(row).forEach(k => {
                if (k.startsWith('month') || k.startsWith('year')) {
                    const v = row[k];
                    row[k] = v && v.toFixed ? v.toFixed(2) : v;
                }
            })
            if (row.duration === this.hr) {
                row.durationvalue = `${parseInt(row.durationMinutes) * HR_MIN_CONVERSION}`;
            } else if (row.duration === this.days) {
                row.durationvalue = `${parseInt(row.durationMinutes) * DAY_MIN_CONVERSION}`;
            } else {
                row.durationvalue = row.durationMinutes;
            }
        });

        this.ddfData.forEach((element: UIDdfTable) => {
            if (element.duration === this.hr) {
                element.durationMinutes = `${parseInt(element.durationMinutes) * HR_MIN_CONVERSION}`;
            } else if (element.duration === this.days) {
                element.durationMinutes = `${parseInt(element.durationMinutes) * DAY_MIN_CONVERSION}`;
            }
            element.duration = this.minute;
        });
        this.ddfGraph(this.ddfData, this.unit);
        const ddfData: DdfTable[] = this.ddfData.map((row: UIDdfTable) => uItoAPIDDfTable(row));
        const ddf: DepthDurationFrequency = this.ddf
            ? {
                ddfTable: ddfData,
                pk: this.ddf.pk,
                id: this.ddf.id,
                docType: this.ddf.docType,
            }
            : {
                ddfTable: ddfData,
            };

        return this.customerService.saveDepthDuration(this.customerDetails.customerID, ddf).pipe(
            tap((result: DepthDurationFrequency[]) => {
                if (result) {
                    this.updateUserConfig(durations);
                    this.ddfData = tableDataCopy;
                    this.applyDdfSource(this.ddfData);
                    if (showSuccessNotification) {
                        this.snackBarNotificationService.raiseNotification(this.savedDdfText, this.dismissBtn, {
                            duration: SNACKBAR_DURATION,
                        });
                    }
                }
                this.savedDdfState = this.getCurrentDdfState();
                this.updateDdfChangeState();
                this.isLoadingState = false;
            }),
            map(() => true),
            catchError(() => {
                this.updateDdfChangeState();
                this.isLoadingState = false;
                this.snackBarNotificationService.raiseNotification(this.failedDdfText, this.dismissBtn, {}, false);
                return of(false);
            }),
        );
    }

    /**
      Method to create storm or dry day definition on form submission
    **/
    public saveRainEventInfo(definitionEvent: 'stormDefinition' | 'dryDefinition'): void {
        this.isLoadingState = true;
        if (definitionEvent === 'stormDefinition' && this.customerDetails) {
            this.createStormDefinition();
        } else if (definitionEvent === 'dryDefinition' && this.customerDetails) {
            this.createDryDayDefinition();
        }
    }

    public saverange(): void
    {
        this.updateDdfChangeState();
    }

    private updateDdfChangeState(): void
    {
        this.updateRainfallChangeState();
    }

    /**
      Method to get storm definition of currently editing customer in created previously
    **/
    public getStormDifinitionData() {
        this.customerService.getStormDefinition(this.customerDetails.customerID).subscribe(
            (result: StormDefinition[]) => {
                if (result.length > 0) {
                    const { unitsType } = this.customerDetails;
                    const isMetric = unitsType === UnitOfMeasureType.METRIC;

                    this.stormDefinitionDetails.minRainfallThreshold = isMetric ? Number(result[0].minRainfallThreshold).toFixed(1) : Number(result[0].minRainfallThreshold).toFixed(2) || '0';
                    this.stormDefinitionDetails.minimumTimeBetweenEventsMinutes =
                        result[0].minimumTimeBetweenEventsMinutes >= 0
                            ? result[0].minimumTimeBetweenEventsMinutes
                            : undefined;
                    this.stormDefinitionDetails.id = result[0].id || undefined;
                }
                this.savedStormDefinitionState = this.getCurrentStormDefinitionState();
                this.stormDefnitionForm?.form?.markAsPristine();
                this.updateRainfallChangeState();
                this.isLoadingState = false;
            },
            () => {
                this.savedStormDefinitionState = this.getCurrentStormDefinitionState();
                this.updateRainfallChangeState();
                this.isLoadingState = false;
            },
        );
    }

    /**
      Method to create/update storm definition calls customer service, inturn for definition creation
    **/
    public createStormDefinition(): void {
        this.createStormDefinition$(true).subscribe();
    }

    private createStormDefinition$(showSuccessNotification: boolean): Observable<boolean> {
        this.isLoadingState = true;
        const stormDefinition: StormDefinition = {
            minRainfallThreshold: this.stormDefinitionDetails.minRainfallThreshold,
            minimumTimeBetweenEventsMinutes: this.stormDefinitionDetails.minimumTimeBetweenEventsMinutes,
            id: this.stormDefinitionDetails.id,
        };

        return this.customerService.createStormDefinition(this.customerDetails.customerID, stormDefinition).pipe(
            tap(() => {
                if (showSuccessNotification) {
                    this.snackBarNotificationService.raiseNotification(this.stormCreationSuccessfultxt, this.dismissBtn, {
                        duration: SNACKBAR_DURATION,
                    });
                }
                this.savedStormDefinitionState = this.getCurrentStormDefinitionState();
                this.stormDefnitionForm.form.markAsPristine();
                this.updateRainfallChangeState();
                this.getStormDifinitionData();
            }),
            map(() => true),
            catchError(() => {
                this.snackBarNotificationService.raiseNotification(this.stormCreationFailurefultxt, this.dismissBtn, {
                    panelClass: 'custom-error-snack-bar',
                }, false);
                this.isLoadingState = false;
                return of(false);
            }),
        );
    }

    /**
      Method to get dry definition of currently editing customer if created previously
    **/
    public getDryDefinitionData() {
        this.customerService.getDryDayDefinition(this.customerDetails.customerID).subscribe(
            (result: DryDayDefinition) => {
                if (result) {
                    this.dryDefinitionDetails.id = result.id;
                    this.dryDefinitionDetails.minimumFlowPercentage = result.minFlowPercentage;
                    this.dryDefinitionDetails.maximumFlowPercentage = result.maxFlowPercentage;
                    if (result.dailyMaximum) {
                        result.dailyMaximum.forEach((maximObject: DailyMaximum) => {
                            if (maximObject.dayCount === 1) {
                                this.dryDefinitionDetails.minRainPrevOneDay = this.addZeroes(maximObject.accumulation.toString());
                            } else if (maximObject.dayCount === 3) {
                                this.dryDefinitionDetails.minRainPrevThreeDays = this.addZeroes(maximObject.accumulation.toString());
                            } else if (maximObject.dayCount === 5) {
                                this.dryDefinitionDetails.minRainPrevFiveDays = this.addZeroes(maximObject.accumulation.toString());
                            }
                        });
                    }
                }
                this.savedDryDefinitionState = this.getCurrentDryDefinitionState();
                this.dryDefinitionForm?.form?.markAsPristine();
                this.updateRainfallChangeState();
                this.isLoadingState = false;
            },
            () => {
                this.savedDryDefinitionState = this.getCurrentDryDefinitionState();
                this.updateRainfallChangeState();
                this.isLoadingState = false;
            },
        );
    }

    public addZeroes(num) {
            let returnVal: string;
            const value = Number(num);
            const res = num.split(".");
            if(res.length >= 1) {
                if(this.IsUnitMetric)
                returnVal = value.toFixed(1);
                else
                returnVal = value.toFixed(2);
            }
        return returnVal;
        }

    /**
      Method to create/update Dry day definition, calls customer service inturn for definition creation
    **/
    public createDryDayDefinition(): void {
        this.createDryDayDefinition$(true).subscribe();
    }

    private createDryDayDefinition$(showSuccessNotification: boolean): Observable<boolean> {
        this.isLoadingState = true;
        const dryDefinitionObject: DryDayDefinition = {
            id: this.dryDefinitionDetails.id,
            maxFlowPercentage: this.dryDefinitionDetails.maximumFlowPercentage,
            minFlowPercentage: this.dryDefinitionDetails.minimumFlowPercentage,
            dailyMaximum: [
                {
                    dayCount: 1,
                    accumulation: Number(this.dryDefinitionDetails.minRainPrevOneDay),
                },
                {
                    dayCount: 3,
                    accumulation: Number(this.dryDefinitionDetails.minRainPrevThreeDays),
                },
                {
                    dayCount: 5,
                    accumulation: Number(this.dryDefinitionDetails.minRainPrevFiveDays),
                },
            ],
        };

        return this.customerService.createDryDefinition(this.customerDetails.customerID, dryDefinitionObject).pipe(
            tap(() => {
                if (showSuccessNotification) {
                    this.snackBarNotificationService.raiseNotification(this.dryDayCreationSuccessfultxt, this.dismissBtn, {
                        duration: SNACKBAR_DURATION,
                    });
                }
                this.savedDryDefinitionState = this.getCurrentDryDefinitionState();
                this.dryDefinitionForm.form.markAsPristine();
                this.updateRainfallChangeState();
                this.getDryDefinitionData();
            }),
            map(() => true),
            catchError(() => {
                this.snackBarNotificationService.raiseNotification(this.dryDayCreationFailuretxt, this.dismissBtn, {
                    panelClass: 'custom-error-snack-bar',
                }, false);
                this.isLoadingState = false;
                return of(false);
            }),
        );
    }

    public applyUnitRounding(value: number) {
        if (!value) {
            return value === 0 ? '0' : '';
        }
        const place: number = Number(this.customerUnit) === 2 ? 1 : 2;
        return Number(value).toFixed(place);
    }

    public onShowDDFColumnChange(name: string, event: MatCheckboxChange) {
        this.doDDFColumnChange(name, event.checked);
    }

    private doDDFColumnChange(name: string, isChecked: boolean, trackChanges = true): void {
        const columnDef = this.ddfTableColumnDefs.find((v) => v.name === name);
        if (columnDef) {
            columnDef.show = isChecked;
        }

        this.updateDDFColumns();
        if (trackChanges) {
            this.updateDdfChangeState();
        }
    }

    private updateDDFColumns() {
        this.rainfallDataColumns = this.ddfTableColumnDefs.filter((v) => v.show).map((v) => v.name);
    }

    private applyTranslations() {
        const translationKeys: Array<string> = [
            'COMMON.DISMISS_TEXT',
            'CUSTOMER_EDITOR.RAIN_PROFILE.STORM_EVENT.STORM_EVENT_CREATION_SUCCESSFUL',
            'CUSTOMER_EDITOR.RAIN_PROFILE.DDF.DDF_CREATION_SUCCESSFUL',
            'CUSTOMER_EDITOR.RAIN_PROFILE.DDF.DDF_CREATION_FAILED',
            'CUSTOMER_EDITOR.RAIN_PROFILE.STORM_EVENT.STORM_EVENT_CREATION_FAILED',
            'CUSTOMER_EDITOR.RAIN_PROFILE.DRY_DAY.DRY_DAY_EVENT_CREATION_SUCCESSFUL',
            'CUSTOMER_EDITOR.RAIN_PROFILE.DRY_DAY.DRY_DAY_EVENT_CREATION_FAILURE',
            'CUSTOMER_EDITOR.RAIN_PROFILE.RAINFALL_DURATION.DELETED_ROW_SUCCESS_MESSAGE',
            'VAULT.VAULT_DASHBOARD.FILES_UPLOAD_SUCCESS',
            'COMMON.DURATION_MINUTE',
            'CUSTOMER_EDITOR.RAIN_PROFILE.STORM_EVENT.IN',
            'CUSTOMER_EDITOR.RAIN_PROFILE.STORM_EVENT.MM',
            'CUSTOMER_EDITOR.RAIN_PROFILE.METHOD_CREATION_SUCCESSFUL',
            'CUSTOMER_EDITOR.RAIN_PROFILE.METHOD_CREATION_FAILED',
            'CUSTOMER_EDITOR.RAIN_PROFILE.DDF.FILE_TYPE_ERR_DDF_FORMAT',
            'COMMON.HR',
            'COMMON.MIN',
            'COMMON.DAYS',
        ];
        this.translate.get(translationKeys).subscribe((values) => {
            this.hr = values['COMMON.HR'];
            this.minute = values['COMMON.MIN'];
            this.days = values['COMMON.DAYS'];
            this.dismissBtn = values['COMMON.DISMISS_TEXT'];
            this.stormCreationSuccessfultxt =
                values['CUSTOMER_EDITOR.RAIN_PROFILE.STORM_EVENT.STORM_EVENT_CREATION_SUCCESSFUL'];
            this.savedDdfText = values['CUSTOMER_EDITOR.RAIN_PROFILE.DDF.DDF_CREATION_SUCCESSFUL'];
            this.failedDdfText = values['CUSTOMER_EDITOR.RAIN_PROFILE.DDF.DDF_CREATION_FAILED'];
            this.savedMethod = values['CUSTOMER_EDITOR.RAIN_PROFILE.METHOD_CREATION_SUCCESSFUL'];
            this.failedToSave = values['CUSTOMER_EDITOR.RAIN_PROFILE.METHOD_CREATION_FAILED'];
            this.badDDFFormatText = values['CUSTOMER_EDITOR.RAIN_PROFILE.DDF.FILE_TYPE_ERR_DDF_FORMAT'];
            this.stormCreationFailurefultxt =
                values['CUSTOMER_EDITOR.RAIN_PROFILE.STORM_EVENT.STORM_EVENT_CREATION_FAILED'];
            this.dryDayCreationSuccessfultxt =
                values['CUSTOMER_EDITOR.RAIN_PROFILE.DRY_DAY.DRY_DAY_EVENT_CREATION_SUCCESSFUL'];
            this.dryDayCreationFailuretxt =
                values['CUSTOMER_EDITOR.RAIN_PROFILE.DRY_DAY.DRY_DAY_EVENT_CREATION_FAILURE'];
            this.rainFallDepthDurationRowDeletionMsg =
                values['CUSTOMER_EDITOR.RAIN_PROFILE.RAINFALL_DURATION.DELETED_ROW_SUCCESS_MESSAGE'];
            this.filesUploadSuccessMsg = values['VAULT.VAULT_DASHBOARD.FILES_UPLOAD_SUCCESS'];
            this.unitInInch = values['CUSTOMER_EDITOR.RAIN_PROFILE.STORM_EVENT.IN'];
            this.unitInMM = values['CUSTOMER_EDITOR.RAIN_PROFILE.STORM_EVENT.MM'];
        });
    }

    // TODO: WPS - have a single function for arrow events that accepts
    //       the index and a direction
    public arrowUpEvent(index: number) {
        event.preventDefault();
        const nextrow = this.ddfTableSource.data[index - 1];
        if (nextrow) {
            this.setPointer(index - 1);
        }
    }

    public arrowDownEvent(index: number) {
        event.preventDefault();
        const nextrow = this.ddfTableSource.data[index + 1];
        if (nextrow) {
            this.setPointer(index + 1);
        }
    }

    public arrowLeftEvent(index: number) {
        event.preventDefault();
        if (this.columnIndex > 0) {
            this.columnIndex--;
        } else {
            index--;
            this.columnIndex = 15;
        }
        const nextrow = this.ddfTableSource.data[index];
        if (nextrow) {
            this.setPointer(index, false);
        }
    }

    public arrowRightEvent(index: number) {
        event.preventDefault();
        if (this.columnIndex < 15) {
            this.columnIndex++;
        } else {
            index++;
            this.columnIndex = 0;
        }
        const nextrow = this.ddfTableSource.data[index];
        if (nextrow) {
            this.setPointer(index);
        }
    }

    private getNextColumnIndex(index: number, isRight = true) {
        let columnIndex = -1;

        while (columnIndex === -1) {
            columnIndex = this.rainfallDataColumns.indexOf(this.ddfTableColumnDefs[index].name);

            index = isRight ? index + 1 : index - 1;
        }

        return columnIndex;
    }

    public setPointer(index: number, isRight = true) {
        const displayedColumnIndex = this.getNextColumnIndex(this.columnIndex, isRight)

        this.columnIndex = this.ddfTableColumnDefs.findIndex(v => v.name === this.rainfallDataColumns[displayedColumnIndex]);

        this.matTable
            ._getRenderedRows(this.matTable._rowOutlet)
        [index].children[displayedColumnIndex].getElementsByTagName('input')[0]
            .focus();
    }

    public setColumn(index) {
        this.columnIndex = index;
    }

    private initializeChartSettings() {
        const { unitsType } = this.customerDetails;
        const isMetric = unitsType === UnitOfMeasureType.METRIC;

        this.unit = isMetric ? this.unitInMM : this.unitInInch;
        this.IsUnitMetric = (this.unit == this.unitInMM)? true : false;

    }

    private populateDurationsFromUserConfig(durations: { type: string; value: number }[]) {
        if (!durations || !this.ddfData || this.ddfData.length !== durations.length) {
            return;
        }

        durations.forEach((v, i) => {
            const ddfItem = this.ddfData[i];
            let durationValue: number;

            if (v.type === this.durationOptions[0]) {
                durationValue = v.value;
            } else if (v.type === this.durationOptions[1]) {
                durationValue = v.value * HR_MIN_CONVERSION;
            } else {
                durationValue = v.value * DAY_MIN_CONVERSION;
            }

            if (parseInt(ddfItem.durationMinutes) !== durationValue) {
                return;
            }

            ddfItem.duration = v.type;
            ddfItem.durationMinutes = `${v.value}`;
        });
    }

    private getUserConfig(): void {
        this.customerService.getSliicerUserConfig(this.customerDetails.customerID).subscribe(
            (data: SliicerUserConfig) => {
                this.userConfig = data;

                if (this.userConfig) {
                    this.userConfig.hiddenColumns.forEach((columnName: string) =>
                        this.doDDFColumnChange(columnName, false, false),
                    );

                    if (this.userConfig.otherConfig) {
                        const durations: unknown = JSON.parse(this.userConfig.otherConfig);
                        if (this.isDurationConfig(durations)) {
                            this.populateDurationsFromUserConfig(durations);
                        }
                    }
                }

                this.userConfigLoaded = true;
                this.captureDdfStateIfLoaded();
            },
            () => {
                this.userConfigLoaded = true;
                this.captureDdfStateIfLoaded();
            },
        );
    }

    private isDurationConfig(value: unknown): value is Array<{ type: string; value: number }> {
        return Array.isArray(value) && value.every((item: unknown) => {
            if (typeof item !== 'object' || item === null || !('type' in item) || !('value' in item)) {
                return false;
            }

            return typeof item.type === 'string' && typeof item.value === 'number';
        });
    }

    private updateUserConfig(durations: { type: string; value: string }[]) {
        const viewableColumns = this.ddfTableColumnDefs.filter((v) => v.show).map((v) => v.name);
        const hiddenColumns = this.ddfTableColumnDefs.filter((v) => !v.show).map((v) => v.name);

        this.customerService
            .postSliicerUserConfig(this.customerDetails.customerID, {
                ...this.userConfig,
                viewableColumns,
                hiddenColumns,
                otherConfig: JSON.stringify(durations),
            })
            .subscribe();
    }
}
